import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Flex, Tooltip } from 'antd'
import { openModalDeleteArticleItem } from 'src/pages/budget/budgetCategories/model'
import { openModalArticleItem } from 'src/pages/budget/model'
import { ArticleItem, ArticleType } from 'src/pages/budget/types'
import { DescriptionCell } from 'src/pages/budget/components'
import { iconButtonStyle } from 'src/pages/budget/const'

export const getColumnsArticleItems = (article: ArticleType) => [
  {
    title: '№',
    dataIndex: 'fullNumber',
    key: 'fullNumber',
    width: '5%',
  },
  {
    title: 'Название',
    dataIndex: 'name',
    key: 'name',
    width: '17%',
  },
  {
    title: 'Описание',
    dataIndex: 'description',
    key: 'description',
    width: '70%',
    render: (text: string) => <DescriptionCell text={text} />,
  },
  {
    title: '',
    dataIndex: '',
    key: 'action',
    width: '7%',
    render: (_: void, record: ArticleItem) => (
      <Flex justify="center" gap="large" style={{ fontSize: 20 }}>
        <Tooltip title="Удалить пункт">
          <DeleteOutlined
            onClick={() =>
              openModalDeleteArticleItem({
                article,
                articleItem: { ...record },
              })
            }
            style={{ ...iconButtonStyle, color: 'var(--color-red-60)' }}
          />
        </Tooltip>
        <Tooltip title="Редактировать пункт">
          <EditOutlined
            onClick={() =>
              openModalArticleItem({
                article,
                mode: 'edit',
                articleItem: { ...record },
              })
            }
            style={{ ...iconButtonStyle, color: 'var(--color-primary)' }}
          />
        </Tooltip>
      </Flex>
    ),
  },
]
